import { infiniteQueryOptions, keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';
import { api } from '@/api';
import { PaginatedHospitalContactListQueryParams } from '@/api/apis/facilities';
import { hospitalContactsQueryKeys } from './hospital-contacts.keys';
import { DEFAULT_INFINITE_QUERY_OPTIONS } from '@/queries/utils';

export const hospitalContactsQueries = {
  list: (listQuery: PaginatedHospitalContactListQueryParams) =>
    queryOptions({
      queryKey: hospitalContactsQueryKeys.getList(listQuery),
      queryFn: () => api.hospital.getHospitalContactList(listQuery),
      placeholderData: keepPreviousData,
    }),
  infiniteList: (searchPagination: PaginatedHospitalContactListQueryParams) =>
    infiniteQueryOptions({
      queryKey: hospitalContactsQueryKeys.getInfiniteList(searchPagination),
      queryFn: ({ pageParam: pageIndex }) => api.hospital.getHospitalContactList({ ...searchPagination, pageIndex }),
      ...DEFAULT_INFINITE_QUERY_OPTIONS,
    }),
  item: (contactId: string) =>
    queryOptions({
      queryKey: hospitalContactsQueryKeys.getItem(contactId),
      queryFn: () => api.hospital.getHospitalContactById(contactId),
    }),
};

export const useHospitalContactsListQuery = (listQuery: PaginatedHospitalContactListQueryParams) => {
  return useQuery(hospitalContactsQueries.list(listQuery));
};
